var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.45,
    width: 8.55,
    height: 8.55,
    rx: 2,
    fill: "#1877F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.45,
    y: 10.45,
    width: 8.55,
    height: 8.55,
    rx: 2,
    fill: "#1877F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.55,
    height: 8.55,
    rx: 2,
    fill: "#1877F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 10.45,
    width: 8.55,
    height: 8.55,
    rx: 2,
    fill: "#1877F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDashboardActive);
export default __webpack_public_path__ + "static/media/ico-dashboard-active.f33359669ca5080862067d21971cf725.svg";
export { ForwardRef as ReactComponent };